// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"db1cfc91","227":"e792c136","407":"db1cfc91"}[chunkId] + ".chunk.css";
};